<template>
  <v-layout row justify-center>
    <v-dialog v-model="visibility" max-width="290">
      <v-card>
          <v-select
            v-model="select"
            :items="classrooms"
            label="Selecione a sala"
            return-object
            class="pl-2 pr-2 pt-4 mt-0"
            data-test="select-classroom"/>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { user } from '@/services/'
import { mapGetters } from 'vuex'

export default {
  name: 'classroom-selection',

  data: () => ({
    select: null
  }),

  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    selectedClassroom: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    visibility: {
      get () {
        return this.dialog
      },
      set () {
        this.$emit('cancelDialog')
      }
    },

    classrooms () {
      return this.getClassrooms()
    }
  },

  mounted () {
    this.select = this.selectedClassroom
  },

  watch: {
    select (newValue) {
      if (newValue && this.dialog) {
        const { text, value } = newValue
        this.$emit('onSelectClassroom', { text, value })
      }
    }
  },

  methods: {
    ...mapGetters({
      getClassrooms: 'authorizationInfos/getClassrooms'
    }),

    getClassroom () {
      return user.getSelectedClassroom() ? user.getSelectedClassroom() : 'Selecionar sala'
    }
  }

}
</script>
